<mat-toolbar class="toolbar mat-elevation-z4">
  <div class="logo"></div>
  <span class="app-name">Merchant Application</span>
</mat-toolbar>
<router-outlet></router-outlet>
